export const SUPPORTED_UI_LANGS = ['pt-br', 'en', 'es'] as const;
export type SupportedUiLang = (typeof SUPPORTED_UI_LANGS)[number];

const SUPPORTED_UI_LANGS_SET = new Set<SupportedUiLang>(SUPPORTED_UI_LANGS);

export function isSupportedUiLang(value: unknown): value is SupportedUiLang {
  if (typeof value !== 'string') return false;
  return SUPPORTED_UI_LANGS_SET.has(value.trim() as SupportedUiLang);
}
